import React from "react";
import { Tabs } from "antd";
import UploadedOrdersTab from "./Tabs/UploadedOrdersTab.js";
import OpenedOrdersTab from "./Tabs/OpenedOrdersTab.js";
import CompletedOrdersTab from "./Tabs/CompletedOrdersTab.js";

const OrdersAutomation = () => {
  return (
    <div style={{ padding: 24 }}>
      <Tabs
        defaultActiveKey="3"
        items={[
          {
            key: "1",
            label: "Completed Orders",
            children: <CompletedOrdersTab />,
          },
          {
            key: "2",
            label: "Upload Orders",
            children: <UploadedOrdersTab />,
          },
          {
            key: "3",
            label: "Opened Orders",
            children: <OpenedOrdersTab />,
          },
        ]}
      />
    </div>
  );
};

export default OrdersAutomation;